/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/crafted/account/overview'
        icon='/media/icons/duotune/general/profile.svg'
        title='حساب کاربری '
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/crafted/account/overview'
        icon='/media/icons/duotune/general/profile.svg'
        title=' اطلاعات حساب   '
        fontIcon='bi-layers'
      />
      {/* <AsideMenuItem
        to='/stock/sales'
        title='     خرید سهام  '
        icon='/media/icons/duotune/general/buy.svg'
        fontIcon='bi-layers'
      /> */}
       <AsideMenuItem
        to='/stock/transfer'
        title='انتقال سهام'
        icon='/media/icons/duotune/general/buy.svg'
        fontIcon='bi-layers'
      />
      {/* <AsideMenuItem
        to='/stock/market'
        title='     بازارچه  سهام  '
        icon='/media/icons/duotune/general/chartBar.svg'
        fontIcon='bi-layers'
      /> */}
      <AsideMenuItem
        to='/stock/orders'
        title=' سفارشات خرید سهم '
        icon='/media/icons/duotune/general/chartBar.svg'
        fontIcon='bi-layers'
      />

      <div className='menu-item text-right'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section  text-base	 ls-1'>منو </span>
        </div>
      </div>

      <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='  مالی  '
        icon='/media/icons/duotune/communication/w.svg'
        fontIcon='bi-person'
      >
        {/*<AsideMenuItem to='/crafted/account/overview' title='فعالیت های مالی من ' hasBullet={true} />*/}
        {/*<AsideMenuItem to='/crafted/account/settings' title='سرمایه گذاری' hasBullet={true} />*/}
        {/*<AsideMenuItem*/}
        {/*  to='/crafted/account/overview'*/}
        {/*  title='فعالیت های مالی من '*/}
        {/*  hasBullet={true}*/}
        {/*/>*/}
        <AsideMenuItem to='/finance' title='  تراکنش های مالی' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/error'
        title='امور  سهام '
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/Graph.svg'
      >
        {/* <AsideMenuItem to='/stock/sales' title='خرید سهام ' hasBullet={true} /> */}
        <AsideMenuItem to='/stock/orders' title=' سفارشات خرید سهم ' hasBullet={true} />
        <AsideMenuItem to='/stock/shop' title=' فروش سهام' hasBullet={true} />
        <AsideMenuItem to='/stock/transfer' title='انتقال سهام' hasBullet={true} />
        <AsideMenuItem to='/stock/transfer-request-list' title=' لیست درخواست های انتقال' hasBullet={true} />
        <AsideMenuItem to='/stock/Installment' title='پرداخت قسط' hasBullet={true} />
        <AsideMenuItem to='/stock/report' title='گزارش نوسانات سهام' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/request'
        title=' درخواست ها '
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/stock.svg'
      >
        <AsideMenuItem to='/request' title=' ثبت درخواست جدید ' hasBullet={true} />
        <AsideMenuItem to='/request/listrequest' title='   لیست درخواست ها ' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/service'
        title='خدمات '
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen025.svg'
      >
        <AsideMenuItem to='/service' title=' خدمات    ' hasBullet={true} />
        <AsideMenuItem to='/service' title=' سوابق مراجعات   ' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/q&a'
        title='سوالات متداول '
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen025.svg'
      >
        {/* <AsideMenuItem to='/q&a' title=' نحوه خرید سهام  ' hasBullet={true} /> */}
        <AsideMenuItem to='/' title=' نحوه پرداخت اقساط    ' hasBullet={true} />
        <AsideMenuItem to='/' title=' نحوه  صدور قرارداد    ' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        to='/contact'
        icon='/media/icons/duotune/general/call.svg'
        title=' تماس با ما'
        fontIcon='bi-layers'
      />

      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
    </>
  )
}
